import { Dialog } from 'primereact/dialog';
import { useIssueTypeHierarchy } from '../../../Hooks/Features/Hierarchy/useIssueTypeHierarchy';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IssueTypeHierarchyCRUD = () => {

    const { formValue, setFormValue, hierarchyData, renderItem, modalVisible, setModalVisible, modalAction, handleSave, confirmationPopup, setConfirmationPopup, handleDelete } = useIssueTypeHierarchy()

    return (
        <div className="p-2 hierarchy">
            <div className='d-flex justify-content-end my-2'>
                <button onClick={() => setModalVisible(true)}><FontAwesomeIcon icon="fa-solid fa-add" /> New Action</button>
            </div>
            <div>
                {hierarchyData?.map(item => renderItem(item))}
            </div>

            <Dialog header={modalAction === 'add' ? 'Add Issue Type' : 'Edit Issue Type'} visible={modalVisible} modal onHide={() => setModalVisible(false)} draggable={false}>
                <div className="p-fluid">
                    <label className="px-1 fw-semibold">Issue Type Name</label>
                    <input
                        placeholder="Enter Issue Type Name"
                        value={formValue?.issue_type_name}
                        className='input-dd w100'
                        onChange={e => setFormValue((prev) => ({ ...prev, issue_type_name: e.target.value }))}
                    />
                </div>
                <div>
                    <label className="px-1 fw-semibold">Description</label>
                    <textarea rows="3" placeholder="Enter description" value={formValue?.issue_type_description} name="description" onChange={(e) => setFormValue((prev) => ({ ...prev, issue_type_description: e.target.value }))}
                        className="w100"></textarea>
                </div>
                <div className="mt-2 d-flex justify-content-end gap-2">
                    <button className='btn-primary' onClick={handleSave} >Save</button>
                    <button className='btn-default' onClick={() => setModalVisible(false)} >Cancel</button>
                </div>
            </Dialog>
            <CommanDialog visible={confirmationPopup?.show} handleClose={() => setConfirmationPopup({ show: false, data: "" })} handleFun={() => handleDelete(confirmationPopup?.data)} message={`Are you sure you want to delete "${confirmationPopup?.data?.issue_type_name}" and all its children?`} />
        </div>
    );
}

export default IssueTypeHierarchyCRUD;